import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import { firebaseConfig } from "src/Utils/envConfig";

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const authFireabse = firebase.auth();
export const db = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();

provider.setCustomParameters({
    prompt: 'select_account',
    access_type: 'offline'
});
// provider.addScope('https://www.googleapis.com/auth/calendar');

export const signInFireabse = ()=> authFireabse.signInWithPopup(provider)

export const signOutGoogle=()=> authFireabse.signOut();
